import Axios from 'axios';
import env from '@/config/env';
import qs from 'qs';
const response_type = 'code';
const redirect_uri = `${env.redirectHost}/oauth`;
const state = '';
const loginUrl = `${env.apiHost}/login/Authentication/get_code`;
const getTokenUrl = `${env.apiHost}/login/Authentication/get_token`;
const refreshTokenUrl = `${env.apiHost}/login/Authentication/get_refresh_token`;
const oAuthLoginUrl = `${env.oauthHost}/oauth/authorize`;
const oAuthTokenUrl = `${env.oauthHost}/oauth/token`;
const userInfoUrl = `${env.apiHost}/api/organization/user/info_login`;
const oauthLogin = `${env.oauthHost}/login/mobile/ajax`;
const formUrl = `${env.apiHost}/api/runtime/form/get_message_form_url`;
const configUrl = `${env.apiHost}/public/system/config`;
const signDingTalkUrl = `${env.oauthHost}/api/dingtalk/sign`;
export default {
    /**
   * 获取钉钉签名信息
   * @param url 当前获取签名的url
   */
    getDingTalkSignature(params) {
        return Axios.get(`${signDingTalkUrl}`, {
            params
        });
    },
    getSSOToken(params) {
        // 解决跨端口访问时跨域的问题
        return Axios.post(`${oAuthTokenUrl}`, qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    getRefreshToken(params) {
        return Axios.get(`${refreshTokenUrl}`, { params });
    },
    getUserInfo() {
        return Axios.get(`${userInfoUrl}`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    login(params) {
        return Axios.post(`${loginUrl}`, params);
    },
    getToken(params) {
        return Axios.get(`${getTokenUrl}`, { params });
    },
    /**
     * 获取系统环境配置
     */
    getSystemConfig() {
        return Axios.get(`${configUrl}`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
    },
    /**
     * 使用钉钉授权码进行登陆
     * @param params
     */
    oauthLogin(params) {
        return Axios.get(`${oauthLogin}`, {
            params
        });
    },
    /**
     * 获取消息打开表单跳转地址
     * @param params
     */
    getFormUrl(params) {
        return Axios.get(`${formUrl}`, {
            params
        });
    },
    /**
   * 获取加密公钥
   */
    getRsaKey() {
        return Axios.get(`${env.apiHost}/public/getKey`);
    },
    /**
     * 修改用户密码
     * @param params
     */
    changePassword(params) {
        return Axios.put('/api/user/modify_user_password', params);
    },
    // OAuthLoginUrl: `${oAuthLoginUrl}?client_id=${env.client_id}&response_type=${response_type}&scope=${env.scope}&state=${state}&redirect_uri=${redirect_uri}`
    /**
     * 退出登录
     */
    logout(params) {
        return Axios.post('/api/logout', params, {
            headers: {
                Authentication: `Bearer ${params.access_token}`
            }
        });
    },
    getDepts() {
        return Axios.get(`${env.apiHost}/public/relatedcorp/all_corp_info`);
    }
};
